/*
 * Tracking Event Admin - Subscriptions Management - Add Office Type Subscriptions Dialog
 *
 * Angular Module: trackerbase-app.views.trackerbase-admin.office-type-event-subscriptions-editor-dialog
 * Controller: officeTypeSubscriptionsEditorCtrl
 * Consumers should add a dependency on ngAnimate, ngSanitize, ui.bootstrap, kendo.directives, and the AllOfficeTypes Service Module.
 *
 */

import Assert from "tbAssert";
import MessageQueue from "../../models/MessageQueue";

import AllOfficeTypesServiceModule from "../../services/AllOfficeTypesService";
import SubscriptionEditorError from "tbClient/views/trackerbase-admin/SubscriptionEditorError";

const mScopeSvc = new WeakMap();
const mSanitizeSvc = new WeakMap();
const mModalInstance = new WeakMap();
const mAllOfficeTypesSvc = new WeakMap();

const messageQueueType = "danger";
const mErrorMessageQueue = new WeakMap();

const mOfficeTypeSubsToAdd = new WeakMap();
const mOfficeTypeDataSource = new WeakMap();
const mOfficeTypeDataIsReady = new WeakMap();
const mAddOfficeTypeSubsSelectorOptions = new WeakMap();

class OfficeTypeSubscriptionsEditorController {
    constructor($scope, $sanitize, $uibModalInstance, AllOfficeTypes) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($sanitize != null, "Assertion Failure: Missing NgSanitize Service Dependency");
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing Modal Instance Service Dependency");
        Assert.StrictAssert(AllOfficeTypes != null, "Assertion Failure: Missing All Office Types Service Dependency");
     
        mScopeSvc.set(this, $scope);
        mSanitizeSvc.set(this, $sanitize);
        mModalInstance.set(this, $uibModalInstance);
        mAllOfficeTypesSvc.set(this, AllOfficeTypes);

        mOfficeTypeDataSource.set(this, []);
        mOfficeTypeDataIsReady.set(this, null);

        mErrorMessageQueue.set(this, new MessageQueue(messageQueueType));
        mOfficeTypeSubsToAdd.set(this, []);

        AllOfficeTypes
            .GetOfficeTypes()
            .then(
                (allOfficeTypeData) => {
                    Array.prototype.push.apply(mOfficeTypeDataSource.get(this), allOfficeTypeData);
                    mOfficeTypeDataIsReady.set(this, true);
                },
                (errorResponse) => {
                    mErrorMessageQueue.get(this).publishMessage(errorResponse);
                    mOfficeTypeDataIsReady.set(this, false);
                }
            );

        mAddOfficeTypeSubsSelectorOptions.set(this, {
            dataSource: mOfficeTypeDataSource.get(this),
            filter: "startsWith",
            delay: 500,
            dataTextField: "officeTypeName",
            dataValueField: "officeTypeId"
        });
    }

    get errorMessageQueue() {
        return mErrorMessageQueue.get(this);
    }

    get errorMessages() {
        return mErrorMessageQueue.get(this).messages;
    }

    closeErrorMessage(idx) {
        mErrorMessageQueue.get(this).removeMessageAtIdx(idx);
    }

    get officeTypeSubsToAdd() {
        return mOfficeTypeSubsToAdd.get(this);
    }

    set officeTypeSubsToAdd(updatedVal) {
        mOfficeTypeSubsToAdd.set(this, updatedVal);
    }

    get addOfficeTypeSubsSelectorOptions() {
        return mAddOfficeTypeSubsSelectorOptions.get(this);
    }

    get officeTypeDataIsReady() {
        return mOfficeTypeDataIsReady.get(this);
    }

    canAddOfficeTypeSubs() {
        return (mOfficeTypeSubsToAdd.get(this).length > 0);
    }

    cancel() {
        mModalInstance.get(this).dismiss(SubscriptionEditorError.MakeEditorCancelledResult());
    }

    ok() {
        let selectedOfficeTypes = this.officeTypeSubsToAdd.map((ot) => ot.officeTypeId);
        mModalInstance.get(this).close({
            subs: { OfficeType: selectedOfficeTypes },
            msgs: []
        });
    }


}

OfficeTypeSubscriptionsEditorController.$inject = [
    "$scope",
    "$sanitize",
    "$uibModalInstance",
    "AllOfficeTypes"
];

OfficeTypeSubscriptionsEditorController.dependencies = [
    "ngAnimate",
    "ngSanitize",
    "ui.bootstrap",
    "kendo.directives",
    AllOfficeTypesServiceModule
];

OfficeTypeSubscriptionsEditorController.template = require("./OfficeTypeSubscriptionsEditorDialog.tpl.html");

OfficeTypeSubscriptionsEditorController.controllerAs = "tbOfficeTypeSubMgr";

export default OfficeTypeSubscriptionsEditorController;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/OfficeTypeSubscriptionsEditorDialog.js
// module id = YO8/
// module chunks = 1